import React, { useState } from 'react'
import TextInputFloat from '../../common/components/textInput/TextInputFloat';
import { Listbox } from '@headlessui/react';
import transactionService from '../../../api/services/transactionService';
import { BsCopy } from "react-icons/bs";

const Deposite = (props) => {
    const { t, accountList, loading, userDetails, setIsLoading, setIsModalOpen,setMessage,handleSongClick } = props;
    const [transactionNo, setTransactionNo] = useState('');
    const [amount, setAmount] = useState('');
    const [remark, setRemark] = useState('');
    const [errorText, setErrorText] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSubmit = async (e) => {
        handleSongClick();
        e.preventDefault();
        if (selectedOption === null) {
            setErrorText("Please select account!!");
            return;
        }
        if (transactionNo.length !== 6) {
            setErrorText("Please fill last six number of transaction no !!");
            return;
        }
        // const payload = {
        //     userId: Number(userDetails.userId),
        //     transactionNo: transactionNo,
        //     remark: remark,
        //     amount: Number(amount),
        //     bankAccountId: Number(selectedOption.bankAccountId),
        //     isAdmin: false
        // }

        // console.log("payload", payload);

        try {
            setErrorText(null);
            setIsLoading(true);
            await transactionService.createDeposit({
                userId: Number(userDetails.userId),
                transactionNo: transactionNo,
                remark: remark,
                amount: Number(amount),
                bankAccountId: Number(selectedOption.bankAccountId),
                isAdmin: false
            });
            setIsModalOpen(true);
            //setIsSuccess(true);
            setMessage('Process Successfully');
            setIsLoading(false);
            setTransactionNo('');
            setAmount('');
            setRemark('');
            setSelectedOption(null);
            setIsModalOpen(true);
        } catch (error) {
            //setIsSuccess(false);
            setIsLoading(false);
            setMessage('Sending Fail!');
            setIsModalOpen(true);
            console.error('API request error:', error);
        }
    };

    const handleCopy = () => {
        if (selectedOption === null) {
            setErrorText("Please select account !!");
            return;
        }
        navigator.clipboard.writeText(selectedOption.bankAccountNumber);
        setErrorText(`Copied : ${selectedOption.bankAccountNumber} `);
    }

    return (
        <div className="z-50 flex flex-col mt-5 mx-4 sm:mx-0 h-[60vh] bg-white/[0.2] dark:backdrop-blur-sm backdrop-blur-sm dark:bg-primary/[0.2] dark:bg-opacity-30 bg-opacity-30 rounded-md shadow border border-white border-opacity-20">
            <form
                onSubmit={handleSubmit}
                className="flex flex-col justify-center items-center h-full rounded-b-md shadow-md px-6 md:px-16 space-y-4"
            >
                <p>{t('deposite')}</p>
                <div className='relative'>
                <SelectBox accountList={accountList} loading={loading} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
                <BsCopy className="absolute top-10 right-2 dark:text-white" size={18} onClick={handleCopy}/>
                </div>
                <TextInputFloat
                    id={'transactionNo'}
                    value={transactionNo}
                    type="number"
                    setValue={setTransactionNo}
                    placeholder={''}
                    max={6}
                    label={'Transaction No'}
                />
                <TextInputFloat
                    id={'amount'}
                    placeholder={''}
                    label={'Amount'}
                    value={amount}
                    type="number"
                    setValue={setAmount}
                />
                <TextInputFloat
                    id={'remark'}
                    placeholder={''}
                    label={'Remark'}
                    value={remark}
                    type="text"
                    required={false}
                    setValue={setRemark}
                />
                <span className={`text-xs ${errorText?.includes("Copied") ? 'text-black dark:text-white' : 'text-red-600'}`}>{errorText}</span>
                <div className="flex w-full mt-4 text-center justify-center">
                    <button
                        className="py-2 px-8 w-[80%] mt-4 bg-blue-500 rounded-md shadow border border-blue-500 border-opacity-25"
                        type="submit"
                    >
                        <span className='text-white'>{t('send')}</span>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default Deposite;

const SelectBox = ({ accountList, loading, setSelectedOption, selectedOption }) => {


    const handleSelectChange = (option) => {
        setSelectedOption(option);
    };

    return (
        <div className="w-64 mx-auto mt-6">
            <Listbox value={selectedOption} onChange={handleSelectChange}>
                <div className="relative">
                    <Listbox.Button className="w-full px-5 py-2 text-left bg-white dark:bg-transparent border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                        {selectedOption ? (
                                <div className="flex items-center">
                                    <img
                                        src={`/logo/${selectedOption.bankType}.png`} // Assuming the logos are in public/logo/
                                        alt={selectedOption.bankAccountName}
                                        className="dark:bg-slate-200"
                                        width={30}
                                        style={{ objectFit: 'contain', marginRight: '8px' }}
                                    />
                                    <div className="flex flex-col">
                                        <span className='text-xs dark:text-white'>{selectedOption.bankAccountName}</span>
                                        <span className='text-xs  dark:text-white'>{selectedOption.bankAccountNumber}</span>
                                    </div>
                                </div>
                        ) : (
                            <span className="text-gray-500 text-sm">Select Account</span>
                        )}
                    </Listbox.Button>
                    <Listbox.Options className="absolute w-full mt-1 bg-white z-50 border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto focus:outline-none">
                        {
                            loading ? <span className="text-xs ml-2">Loading .... </span> :
                                accountList.map((account, idx) => (
                                    <Listbox.Option key={idx} value={account}>
                                        {({ active, selected }) => (
                                            <li
                                                className={`${active ? 'bg-blue-500 text-white' : 'text-gray-900'
                                                    } cursor-pointer select-none relative py-2 pl-10 pr-4 rounded-md transition-all duration-200`}
                                            >
                                                <div className="flex items-center">
                                                    <img
                                                        src={`/logo/${account.bankType}.png`} // Assuming the logos are in public/logo/
                                                        alt={account.bankAccountName}
                                                        width={30}
                                                        style={{ objectFit: 'contain', marginRight: '8px' }}
                                                    />
                                                    <div className="flex flex-col">
                                                        <span className={`${selected ? 'font-semibold' : ''
                                                            } block truncate text-xs`}>{account.bankAccountName}</span>
                                                        <span className={`${selected ? 'font-semibold' : ''
                                                            } block truncate text-xs`}>{account.bankAccountNumber}</span>
                                                    </div>
                                                </div>
                                                {selected && (
                                                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600">
                                                        {/* Checkmark Icon */}
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                            className="w-5 h-5"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M16.704 4.704a1 1 0 10-1.408-1.408L8 11.586 4.704 8.29a1 1 0 10-1.408 1.408l4.5 4.5a1 1 0 001.408 0l7-7z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    </span>
                                                )}
                                            </li>
                                        )}
                                    </Listbox.Option>
                                ))}
                    </Listbox.Options>
                </div>
            </Listbox>
        </div>
    )
};